<template>
  <q-dialog v-model="dialogVisible" persistent @hide="onCancel">
    <q-card style="min-width: 700px; max-width: 90vw;">
      <q-card-section class="row items-center bg-primary text-white q-pa-sm">
        <div class="text-h6">选择数据</div>
        <q-space />
        <q-btn icon="fa-solid fa-xmark" flat round dense v-close-popup />
      </q-card-section>

      <q-card-section class="q-pa-sm">
        <div class="row q-gutter-sm">
          <q-input v-model="search.keyword" label="关键字" dense />
          <q-btn label="查询" color="primary" @click="onSearch" dense />
        </div>
      </q-card-section>

      <q-card-section class="q-pa-none">
        <q-table :rows="tableData" :columns="columns" row-key="id" selection="single" v-model:selected="selected"
          :loading="loading" :pagination="pagination" @request="onRequest" @row-dblclick="onRowDoubleClick" flat
          dense />
      </q-card-section>

      <q-card-actions align="right" class="q-pa-sm">
        <q-btn flat label="取消" @click="onCancel" />
        <q-btn color="primary" label="确定" @click="onConfirm" :disable="!selected.length" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, reactive } from 'vue'
import { useQuasar } from 'quasar'
import { request } from "@/request/api";
import { useI18n } from "vue-i18n";

export default {
  name: 'SelectTable',
  emits: ['select'],
  setup(props, context) {
    const $q = useQuasar();
    const { t } = useI18n();

    const dialogVisible = ref(false)
    const search = ref({ keyword: '' })
    const selected = ref([])
    const loading = ref(false)
    const tableData = ref([])
    const pagination = ref({
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 0
    })

    const runtimeParams = reactive({
      field_name: '',
      extra: {}
    })

    const columns = [
      { name: 'id', label: 'ID', field: 'id', align: 'left' },
      { name: 'name', label: '名称', field: 'name', align: 'left' }
    ]

    function open(params = {}) {
      runtimeParams.field = params.field || ''
      runtimeParams.extra = params.extra || {}
      search.value.keyword = ''
      selected.value = []
      pagination.value.page = 1
      dialogVisible.value = true

      // console.log(runtimeParams);

      // 获取列表字段
      request(
        "get_list_cols",
        {
          menu_name: runtimeParams.field.join_table,
          table_name: runtimeParams.field.join_table,
          show_option: false,
        }
      ).then((res) => {
        // console.log(res);

        // console.log("get_form_structure", res);
      })

      fetchData()
    }

    function onSearch() {
      pagination.value.page = 1
      fetchData()
    }

    function onRequest(params) {
      pagination.value = params.pagination
      fetchData()
    }

    async function fetchData() {
      loading.value = true
      try {
        const { page, rowsPerPage } = pagination.value
        const keyword = search.value.keyword


        // request("get_list_data",
        //   {
        //     table_name: param.ext_item.open_area,
        //     search_data: search_data_,
        //     is_fuzzy_query: 0,
        //     current_page: 1,
        //     page_size: 99999,
        //     sort_field: 'id',
        //     sort_order: '',
        //     menu_name: param.ext_item.open_area,
        //     parent_id: '',
        //   }
        // ).then((res) => {
        //   // console.log(res);
        // })

        // 使用 runtimeParams.extra 自定义查询条件
        const all = [
          { id: 1, name: '苹果' },
          { id: 2, name: '香蕉' },
          { id: 3, name: '橘子' },
          { id: 4, name: '西瓜' },
          { id: 5, name: '哈密瓜' },
          { id: 6, name: '草莓' }
        ].filter(row => row.name.includes(keyword))

        const start = (page - 1) * rowsPerPage
        const end = start + rowsPerPage

        tableData.value = all.slice(start, end)
        pagination.value.rowsNumber = all.length
      } catch (err) {
        $q.notify({ type: 'negative', message: '加载失败' })
      } finally {
        loading.value = false
      }
    }

    function onConfirm() {
      if (selected.value.length) {
        context.emit('select', {
          caller: runtimeParams.caller,
          row: selected.value[0]
        })
        dialogVisible.value = false
      }
    }

    function onRowDoubleClick(row) {
      context.emit('select', {
        caller: runtimeParams.caller,
        row
      })
      dialogVisible.value = false
    }

    function onCancel() {
      dialogVisible.value = false
    }

    return {
      dialogVisible,
      search,
      selected,
      tableData,
      columns,
      loading,
      pagination,
      open,
      onSearch,
      onRequest,
      onConfirm,
      onRowDoubleClick,
      onCancel
    }
  }
}
</script>
